import { GET_DATA_FROM_SAP, GET_DATA_FROM_SAP_FULFILLED, GET_DATA_FROM_SAP_REJECTED, PURCHASE_BREAKDOWN } from '../actions'

export default (state = {
  data: null,
  purchaseBreakdown: null,
  fetching: false,
  fetched: false,
  error: null
}, action) => {
  switch (action.type) {
    case GET_DATA_FROM_SAP:
      return { ...state, fetching: true, fetched: false, error: null }
    case GET_DATA_FROM_SAP_FULFILLED:
      const payload = action.payload
      return { ...state, fetching: false, fetched: true, error: null, data: payload }
    case GET_DATA_FROM_SAP_REJECTED:
      return { ...state, fetching: false, fetched: false, error: action.payload, data: null }
    case PURCHASE_BREAKDOWN:
      return { ...state, fetching: false, fetched: false, error: null, purchaseBreakdown: action.payload }
    default:
      return state
  }
}
